var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_653_25409)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_653_25409)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.666,
    cy: 29,
    r: 29,
    fill: "#E8F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.666 33C16.8567 33.57 17.079 34.1233 17.333 34.66M19.499 37.995C19.9223 38.4857 20.374 38.9457 20.854 39.375M25.999 42.333C25.4059 42.1394 24.8254 41.9089 24.261 41.643M29.999 31C30.3946 31 30.7813 30.8827 31.1102 30.6629C31.4391 30.4432 31.6954 30.1308 31.8468 29.7654C31.9982 29.3999 32.0378 28.9978 31.9606 28.6098C31.8834 28.2219 31.6929 27.8655 31.4132 27.5858C31.1335 27.3061 30.7772 27.1156 30.3892 27.0384C30.0012 26.9613 29.5991 27.0009 29.2336 27.1522C28.8682 27.3036 28.5558 27.56 28.3361 27.8889C28.1163 28.2178 27.999 28.6044 27.999 29M29.999 31C29.4686 31 28.9599 30.7893 28.5848 30.4142C28.2097 30.0391 27.999 29.5304 27.999 29M29.999 31V34.333M27.999 29H21.999",
    stroke: "#0069FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.999 42.334C37.363 42.334 43.333 36.364 43.333 29C43.333 21.636 37.363 15.667 29.999 15.667C22.635 15.667 16.666 21.637 16.666 29",
    stroke: "#0069FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_653_25409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(0.666016)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_653_25409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(0.666016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.d05aed8ff86cf977e9bdc67e06e33c85.svg";
export { ForwardRef as ReactComponent };